import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaBlog } from "react-icons/fa";
import { LangContext } from "../../../components/translation/langugeContext";
import { useTranslateKey } from "../../../components/translation/useTranslateKey";
import { IMAGES_BASE_URL } from "../../../api/config";

const Blogs = ({ blogs }) => {
  const navigate = useNavigate();
  const { lang } = useContext(LangContext);
  const t = useTranslateKey();

  const handleClick = () => navigate("/blogs");

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <section id="articles" className="blogs-section container mx-auto px-4">
      <div className="text-center mb-16">
        <h2
          className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3"
          style={{ color: "#F9C835" }}
        >
          <FaBlog style={{ color: "#F9C835" }} />
          <span>{t("articlesTitle")}</span>
        </h2>
      </div>

      {blogs?.length ? (
        <Slider {...sliderSettings}>
          {blogs.map((post) => (
            <div key={post.id} className="px-2">
              <BlogCard
                imageUrl={post.image}
                categoryKey={post.categoryKey}
                date={new Date(post.created_at).toLocaleDateString(
                  lang === "ar" ? "ar-EG" : "en-US",
                  { year: "numeric", month: "short", day: "numeric" }
                )}
                readTime={post.read_time || 0}
                title={post.title}
                title_ar={post.title_ar}
                excerpt={post.excerpt}
                excerpt_ar={post.excerpt_ar}
                id={post.id}
              />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="text-center text-white py-12">
          {t("noBlogPostsFound")}
        </div>
      )}
      <div className="view-all-btn-container">
        <button
          onClick={() => handleClick()}
          className="view-all-btn cursor-pointer rounded-lg text-sm font-medium flex transition-all duration-300 primary-active"
        >
          {t("viewAllBlogs")}
        </button>
      </div>
    </section>
  );
};

const BlogCard = ({
  imageUrl,
  categoryKey,
  date,
  readTime,
  title,
  title_ar,
  excerpt,
  excerpt_ar,
  id,
}) => {
  const t = useTranslateKey();
  const categoryLabel = t(categoryKey);
  const { lang } = useContext(LangContext);
  return (
    <article className="blog-card ">
      <div className="blog-image">
        <img src={`${IMAGES_BASE_URL}${imageUrl}`} alt={categoryLabel} />
        <span className="blog-category">{categoryLabel}</span>
      </div>

      <div className="blog-content">
        <div className={`blog-meta ${lang === "ar" ? "rtl" : "ltr"}`}>
          {lang === "ar" ? (
            <>
              <span>
                {date}
                <i className="far fa-calendar rtl-margin"></i>
              </span>
              <span>
                {readTime.toLocaleString("ar-EG")} {t("min")}
                <i className="far fa-clock rtl-margin"></i>
              </span>
            </>
          ) : (
            <>
              <span>
                <i className="far fa-calendar "></i> {date}
              </span>
              <span>
                <i className="far fa-clock "></i> {readTime} min
              </span>
            </>
          )}
        </div>
        <h3 className="text-white font-semibold text-lg mb-2">
          {lang === "ar" ? title_ar || title : title}
        </h3>
        <p className="text-gray-300 flex-grow">
          {" "}
          {lang === "ar" ? excerpt_ar || excerpt : excerpt}
        </p>
        <div className="mt-4">
          <a
            href={`/blog-details/${id}`}
            className="inline-flex items-center text-[#F9C835] hover:text-white transition-colors"
          >
            <FaBlog className="ml-2" />
            {t("readMore")}
          </a>
        </div>
      </div>
    </article>
  );
};

export default Blogs;
